import { Container } from 'ui/components';
import classNames from 'classnames';
import styles from './ContentSection.module.scss';

export interface ContentSectionProps {
	className?: string;
	width: Models.SectionWidth;
	title: string;
	centered?: boolean;
	children?: React.ReactNode;
}

export const ContentSection: React.FC<ContentSectionProps> = ({ children, width, centered, title, className }) => {
	return (
		<section
			aria-label={title}
			className={classNames(styles.Section, styles.Section___padded, { [styles.Section___centered]: centered }, className)}
		>
			<Container width={width}>
				<div className={styles.Section_content}>{children}</div>
			</Container>
		</section>
	);
};
